import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/HomePage/HomePage.tsx");
